import { environment } from './../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RegisterResetpassService {

  private baseUrl = environment.base_url + `users`;
  private rootURL = environment.base_url;

  constructor(
    private http: HttpClient
  ) { }

  getAccountTypes(): Observable<any> {
    return this.http.get<any>(this.baseUrl + `/getAccountTypes`, {headers:{skip:"true"}});
  }

  register(user): Observable<any> {
    return this.http.post<any>(this.baseUrl + `/signup`, user, {headers:{skip:"true"}});
  }

  getArchiveVideos(): Observable<any> {
    return this.http.get<any>(this.baseUrl + `/user-videos`);
  }

  getListingData(): Observable<any> {
    return this.http.get<any>(this.baseUrl + `/listing`);
  }

  getHomeData(): Observable<any> {
    return this.http.get<any>(this.rootURL + `home`);
  }
}
